<template>
  <div class="address-card" @mouseover="isHover=true" @mouseleave="isHover=false">
    <el-card shadow="never">
      <div slot="header" class="clearfix">
         <span>{{adresseTypeName}}</span>
         <!-- <el-button style="float: right; padding: 3px 0;margin-left:10px;" type="text" >Changer</el-button> -->
       </div>
       <el-row :gutter="20">
         <el-col :span="21" class="company-fiche-info">
           <el-row>
             <el-col :span="1">
               <i class="mdi mdi-map-marker-outline"></i>
             </el-col>
             <el-col :span="23" style="padding-left:2px;">
               <AddressLines :address="address"></AddressLines>
             </el-col>
           </el-row>
          </el-col>
       </el-row>
    </el-card>
  </div>
</template>

<script>
import AddressLines from './Address-Lines'
import axios from "axios"
export default {
	name: 'DefaultAddressCard',
	props: {
    address : Object,
    adresseTypeName : String

	},
	data() {
		return {
      isHover : false,
		}
	},
	components : {
    AddressLines
  },
	methods : {
    removeAddress(index){
      this.$emit('remove',index);
    },
    editAddress(index){
      this.$emit('edit',index);
    },
    mouseOver(){
      this.isHover=true;
    }
	}
}
</script>

<style lang="scss">
@import '../../assets/scss/_variables';



</style>
